import { render } from "./ProductTaxSavePage.vue?vue&type=template&id=1df77b22"
import script from "./ProductTaxSavePage.vue?vue&type=script&lang=js"
export * from "./ProductTaxSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script